module.exports = {"id":"231280","name":"Iván Alejo","rating":"71","photo":"./data/images/photos/4/231280.png","club":{"name":"SD Eibar","logo":"./data/images/clubs/SDEibar.png"},"positions":["MG","MD","MOC","DLD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IvanAlejo0.json
// module id = 1835
// module chunks = 0